export default "__VITE_ASSET__aLog1Uhe__"